import { Component, Input, TemplateRef } from "@angular/core";
import { IGuide, ISelectedModule, IModule } from "../models/guide";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

@Component({
  selector: "mod-activities",
  templateUrl: "./mod-activities.component.html",
  styleUrls: ["./component.css"]
})
export class ModActivitiesComponent {
  constructor(private modalService: BsModalService) { }

  @Input()
  guide: IGuide;

  @Input()
  activeMod: ISelectedModule;

  @Input()
  group: number;

  @Input()
  alpha: string;

  youTubeModalRef: BsModalRef;

  modSelected(mod: ISelectedModule): boolean {
    return JSON.stringify(mod) === JSON.stringify(this.activeMod);
  }

  modComplete(number: number): boolean {

    if (this.guide == null)
      return false;

    const mod = this.getMod({ group: this.group, alpha: this.alpha, number: number });

    return mod.complete;
  }

  getMod(select: ISelectedModule): IModule {
    try {
      return this.guide.groups[this.group].modules.filter(f => f.alpha == select.alpha && f.number == select.number)[0];
    }
    catch (exception) {
      return null;
    }
  }

  getModules(): IModule[] {
    return this.guide.groups[this.group].modules.filter(f => f.alpha == this.alpha);
  }

  openModal(template: TemplateRef<any>) {
    this.youTubeModalRef = this.modalService.show(template);
  }
}
